import React from 'react';
import { Icon } from '@chakra-ui/icons';

export const TwitterIcon = ({ color = 'white' }: { color?: string }) => {
	return (
		<Icon
			width="auto"
			height={{ base: '9px', hashup: '10px' }}
			viewBox="0 0 14 12"
			fill="none"
		>
			<path
				d="M13.5286 0.372345C12.9444 0.784416 12.2976 1.09958 11.6131 1.30571C11.2457 0.883264 10.7574 0.583843 10.2143 0.447946C9.67116 0.312049 9.09941 0.346233 8.57635 0.545874C8.05328 0.745516 7.60416 1.10098 7.2897 1.5642C6.97525 2.02741 6.81064 2.57603 6.81815 3.13584V3.74589C5.74608 3.77369 4.68377 3.53592 3.72584 3.05376C2.76791 2.5716 1.94409 1.86002 1.32775 0.982389C1.32775 0.982389 -1.11242 6.47278 4.37797 8.91296C3.1216 9.76578 1.62494 10.1934 0.107666 10.133C5.59806 13.1833 12.3085 10.133 12.3085 3.11754C12.308 2.94762 12.2916 2.77811 12.2597 2.61121C12.8824 1.99719 13.3217 1.22196 13.5286 0.372345Z"
				fill={color}
			/>
		</Icon>
	);
};
